const rejectApprovalShow = {
  msg: {}
};
export default rejectApprovalShow;



// WEBPACK FOOTER //
// ./src/page/reject/rejectApprovalShow/lang/rejectApprovalShow.zh.js